'use client'

import EnterViewAnimate from '@/components/enterView/animate'
import { usePackageContext } from '../context'
import PackageAu from './au'
import PackageNz from './nz'

export default function PackageContent() {
  const { tab } = usePackageContext()
  return (
    <EnterViewAnimate animate='animate__fadeInUp' className='mt-12.5'>
      {tab === 'au' ? <PackageAu /> : <PackageNz />}
    </EnterViewAnimate>
  )
}
